// =============================================================================
// DATOS DE CONTACTO OFICIALES DE GO SAFELY
// -----------------------------------------------------------------------------
// Un solo sitio para todo lo que el usuario puede marcar, escribir o denunciar.
//
// Por qué existe este archivo: la app tenía el número 809-555-0000 escrito a
// mano en el botón de "Soporte 24/7" y en el SOS del módulo escolar. Ese número
// NO EXISTE — es el equivalente dominicano del "555" de las películas. Un padre
// tocando el SOS de su hijo y escuchando "el número que marcó no está
// disponible" es lo peor que puede pasarle a esta app.
//
// Al estar centralizado, cambiar el número o el correo de soporte es una línea,
// y llega por actualización automática sin recompilar.
// =============================================================================

/** WhatsApp de soporte. Formato internacional sin signos, para wa.me */
export const SOPORTE_WHATSAPP = '18295420292';

/** Teléfono de soporte para llamadas. */
export const SOPORTE_TELEFONO = '+18295420292';

/** Correo de contacto que aparece en Términos y Política de Privacidad. */
export const SOPORTE_CORREO = 'cristaury2912@hotmail.com';

/** Emergencias nacionales de República Dominicana. */
export const EMERGENCIAS_911 = '911';

/** Enlace listo para abrir WhatsApp con un mensaje inicial. */
export function whatsappSoporte(mensaje?: string): string {
  const texto = mensaje ? `?text=${encodeURIComponent(mensaje)}` : '';
  return `https://wa.me/${SOPORTE_WHATSAPP}${texto}`;
}
